import { configureStore } from "@reduxjs/toolkit";
import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from "react-redux";
import authReducer from "./authSlice";
import scrapersReducer from "./scrapersSlice";
import cronJobsReducer from "./cronJobsSlice";
import historyReducer from "./historySlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    scrapers: scrapersReducer,
    cronJobs: cronJobsReducer,
    history: historyReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
